import { DefaultRootState } from '@databases/redux';

import {
  getDatabaseEntryOptional,
  getDatabaseFieldOptional,
  isBrokenDatabase,
} from '../../database/utils';
import { getValueId } from '../../utils';
import { selectDatabaseByContentIdOptional } from '../databases/selectors';

export function selectThreadByValueIdOptional(
  state: DefaultRootState,
  { contentId, fieldId, entryId }: { contentId: string; fieldId: string; entryId: string }
) {
  const database = selectDatabaseByContentIdOptional(state, { contentId });

  if (!database || isBrokenDatabase(database)) {
    return undefined;
  }

  const entry = getDatabaseEntryOptional(database, entryId);
  const field = getDatabaseFieldOptional(database, fieldId);

  if (!entry || !field) {
    return undefined;
  }

  const commentThreads = database.commentThreads;

  const valueId = getValueId(entryId, fieldId);
  if (valueId in commentThreads) {
    return commentThreads[valueId];
  }

  return undefined;
}
export function selectUnresolvedThreadsByValueIdOptional(
  state: DefaultRootState,
  { contentId, fieldId, entryId }: { contentId: string; fieldId: string; entryId: string }
) {
  const threads = selectThreadByValueIdOptional(state, { contentId, fieldId, entryId });
  if (threads) {
    return threads.filter((thread) => !thread.isResolved);
  }

  return undefined;
}

export function selectValueIdFromThreadIdOptional(
  state: DefaultRootState,
  { contentId, threadId }: { contentId: string; threadId: string }
): string | undefined {
  const database = selectDatabaseByContentIdOptional(state, { contentId });

  if (!database || isBrokenDatabase(database)) {
    return undefined;
  }

  const commentThreads = database.commentThreads;

  for (const [key, value] of Object.entries(commentThreads)) {
    if (value.find((thread) => thread.threadId === threadId)) {
      return key;
    }
  }

  return undefined;
}

export function selectValueIdFromReactionsIdOptional(
  state: DefaultRootState,
  { contentId, reactionsId }: { contentId: string; reactionsId: string | undefined }
): string | undefined {
  if (!reactionsId) {
    return undefined;
  }

  const database = selectDatabaseByContentIdOptional(state, { contentId });

  if (!database || isBrokenDatabase(database)) {
    return undefined;
  }

  const commentThreads = database.commentThreads;

  for (const [key, value] of Object.entries(commentThreads)) {
    if (value.find((thread) => thread.reactionsId === reactionsId)) {
      return key;
    }
  }

  return undefined;
}

export function selectThreadIdFromReactionsIdOptional(
  state: DefaultRootState,
  { contentId, reactionsId }: { contentId: string; reactionsId: string | undefined }
): string | undefined {
  if (!reactionsId) {
    return undefined;
  }

  const database = selectDatabaseByContentIdOptional(state, { contentId });

  if (!database || isBrokenDatabase(database)) {
    return undefined;
  }

  const commentThreads = database.commentThreads;

  for (const value of Object.values(commentThreads)) {
    return value.find((thread) => thread.reactionsId === reactionsId)?.threadId;
  }

  return undefined;
}
